import {createAction, props} from '@ngrx/store';
import {
  BankDTO,
  BankFilterDTO,
  BankingTokenResponseDTO,
  BankkontoCreateRequestDTO,
  BankkontoDTO,
  BankkontoFilterDTO,
  BankkontoPageableDTO,
  KontaktResponseDTO,
  NamenspruefungResponseDTO,
  SicherheitsverfahrenDTO,
  ZahlungDTO,
  ZahlungslaufApproveRequestDTO,
  ZahlungslaufCancelRequestDTO,
  ZahlungslaufCreateRequestDTO,
  ZahlungslaufDTO,
  ZahlungslaufResponseDTO,
} from '../../openapi/zahlung-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';

export class TransactionActions {
  private static readonly prefix = '[Transaction] ';

  public static resetCollectivePreview = createAction(this.prefix + 'Reset collective Preview.');

  public static collectivePreviewBrowse = createAction(
    this.prefix + 'Changed page index of payment browser.',
    props<{
      page: number;
    }>(),
  );

  public static setFinalZahlungDtos = createAction(
    this.prefix + 'Set final payments.',
    props<{
      zahlungDtos: ZahlungDTO[];
    }>(),
  );

  public static readUsedAccountBankInfo = createAction(
    this.prefix + 'Read bank by iban.',
    props<{
      iban: string;
    }>(),
  );

  public static loadedUsedAccountBankInfo = createAction(
    this.prefix + 'Loaded bank by iban.',
    props<{
      blz?: string;
      bezeichnung: string;
      bic: string;
    }>(),
  );

  public static readBanks = createAction(
    this.prefix + 'Read banks.',
    props<{
      bankFilter: BankFilterDTO;
    }>(),
  );

  public static banksLoaded = createAction(
    this.prefix + 'Banks loaded.',
    props<{
      banks: Array<BankDTO>;
    }>(),
  );

  public static selectBank = createAction(
    this.prefix + 'Select bank',
    props<{
      bank: BankDTO | undefined;
    }>(),
  );

  public static readUsedAccounts = createAction(
    this.prefix + 'Read the already used accounts',
    props<{
      inhaberId: string;
      filter: BankkontoFilterDTO;
      pageable: BankkontoPageableDTO;
    }>(),
  );

  public static usedAccountsLoaded = createAction(
    this.prefix + 'Used accounts loaded',
    props<{
      usedAccounts: BankkontoDTO[];
    }>(),
  );

  public static getBankingAccessToken = createAction(
    this.prefix + 'Request a banking token from bs service.',
    props<{
      bankingTokenIdentifier: string;
    }>(),
  );

  public static bankingAccessTokenAccessed = createAction(
    this.prefix + 'Successfully got a banking access token from bs service',
    props<{
      token: BankingTokenResponseDTO;
    }>(),
  );

  public static bankingRefreshTokenAccessed = createAction(
    this.prefix + 'Successfully got a banking refresh token from bs service',
    props<{
      token: BankingTokenResponseDTO;
    }>(),
  );

  public static getBankingRefreshToken = createAction(
    this.prefix + 'Request a banking token from bs',
    props<{
      token: string;
    }>(),
  );

  public static deleteBankingToken = createAction(
    this.prefix + 'Delete the banking access/refresh token',
    props<{
      token: string;
    }>(),
  );

  public static allowPollingLogin = createAction(
    this.prefix + 'Updates allowPolling for login',
    props<{
      allowed: boolean;
    }>(),
  );

  public static allowPollingTan = createAction(
    this.prefix + 'Updates allowPolling for tan',
    props<{
      allowed: boolean;
    }>(),
  );

  public static resetBankingToken = createAction(this.prefix + 'Resets the bankingToken');

  public static resetTanData = createAction(this.prefix + 'Sets containsTanData to false');

  public static getKontaktInfo = createAction(
    this.prefix + 'Read kontaktInfo.',
    props<{
      token: string;
      clientIp: string;
      inhaberId: string;
      pollingActive: boolean;
      destination: string;
    }>(),
  );

  public static kontaktInfoLoaded = createAction(
    this.prefix + 'Securityfunctions loaded.',
    props<{
      response: KontaktResponseDTO;
    }>(),
  );

  public static resetKontaktInfo = createAction(this.prefix + 'Resets the kontaktInfo');

  public static selectSecurityfunction = createAction(
    this.prefix + 'Select securityfunction',
    props<{
      securityfunction: SicherheitsverfahrenDTO;
    }>(),
  );

  public static resetSelectedSecurityfunction = createAction(this.prefix + 'Resets the selected securityfunction');

  public static setSicherheitsverfahren = createAction(
    this.prefix + 'Read accounts.',
    props<{
      token: string;
      securityfunction: SicherheitsverfahrenDTO;
      inhaberId: string;
      xs2aTan?: string;
    }>(),
  );

  public static selectAccount = createAction(
    this.prefix + 'Select account',
    props<{
      account: BankkontoDTO;
    }>(),
  );

  public static resetSelectedAccount = createAction(this.prefix + 'Resets the selected account');

  public static resetXs2aUrl = createAction(this.prefix + 'Resets url');

  public static resetAuthentifizierungsgrund = createAction(this.prefix + 'Resets the authentifizierungsgrund');

  public static assignPayment = createAction(
    this.prefix + 'Assign payment',
    props<{
      inhaberId: string;
      token: string;
      clientIp: string;
      request: ZahlungslaufCreateRequestDTO;
      pollingActive: boolean;
    }>(),
  );

  public static createAccount = createAction(
    this.prefix + 'Create new account',
    props<{
      inhaberId: string;
      bankkontoCreateRequest: BankkontoCreateRequestDTO;
    }>(),
  );

  public static createAccountSuccessful = createAction(
    this.prefix + 'New account created',
    props<{
      account: BankkontoDTO;
    }>(),
  );

  public static createAccountError = createAction(
    this.prefix + 'Could not create account',
    props<{
      inhaberId: string;
    }>(),
  );

  public static selectSecurityFunctionException = createAction(
    this.prefix + 'The user needs to select a securityfunction.',
    props<{
      inhaberId: string;
      sicherheitsverfahren: SicherheitsverfahrenDTO[];
      destination: string;
    }>(),
  );

  public static assignPaymentSuccessful = createAction(
    this.prefix + 'The assignment of the payment was successful.',
    props<{
      inhaberId: string;
      response: ZahlungslaufResponseDTO;
    }>(),
  );

  public static strongAuthenticationException = createAction(
    this.prefix + 'Handling for strong authentication exception.',
    props<{
      inhaberId: string;
      pollingActive: boolean;
      destination: string;
      authenticationUrl?: string;
      authentifizierungsgrund?: string;
      response?: ZahlungslaufResponseDTO;
      balanceStrongAuthenticationExceptionOccurred: boolean;
    }>(),
  );

  public static vopException = createAction(
    this.prefix + 'Handling for verification of payee exception.',
    props<{
      namenspruefungResponseDto: NamenspruefungResponseDTO;
    }>(),
  );

  public static approvePayment = createAction(
    this.prefix + 'Approves the payment.',
    props<{
      inhaberId: string;
      token: string;
      zahlungslaufId?: string;
      request: ZahlungslaufApproveRequestDTO;
      pollingActive: boolean;
    }>(),
  );

  public static approvePaymentSuccessful = createAction(
    this.prefix + 'The approvement of the payment was successful.',
    props<{
      response: ZahlungslaufResponseDTO;
    }>(),
  );

  public static cancelPayment = createAction(
    this.prefix + 'Cancel payment.',
    props<{
      inhaberId: string;
      token: string;
      clientIp: string;
      zahlungslaufId: string;
      request: ZahlungslaufCancelRequestDTO;
    }>(),
  );

  public static cancelZahlungslaufSuccess = createAction(
    this.prefix + 'The cancellation of the payment was successful.',
    props<{
      zahlungslaufDto: ZahlungslaufDTO;
    }>(),
  );

  public static cancelZahlungslaufFailure = createAction(
    this.prefix + 'The cancellation of the payment failed.',
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  public static resetZahlungslaufResponse = createAction(this.prefix + 'Resets the ZahlungslaufResponse.');

  public static resetExecutionDate = createAction(this.prefix + 'Resets the executiondate.');

  public static selectPreview = createAction(
    this.prefix + 'Select preview payment out of collective transfer.',
    props<{
      zahlungDto: ZahlungDTO;
    }>(),
  );

  public static setXs2aTan = createAction(
    this.prefix + 'Set xs2a tan (code).',
    props<{
      tan: string;
    }>(),
  );

  public static updateBalance = createAction(
    this.prefix + 'Update balance',
    props<{
      inhaberId: string;
      iban: string;
      token: string;
      clientIp: string;
    }>(),
  );

  public static updateBalanceStrong = createAction(
    this.prefix + 'Update balance strong',
    props<{
      inhaberId: string;
      iban: string;
      token: string;
      securityfunction: SicherheitsverfahrenDTO;
      tan: string;
    }>(),
  );

  public static balanceUpdated = createAction(
    this.prefix + 'Balance updated',
    props<{
      account: BankkontoDTO;
    }>(),
  );

  public static balanceUpdatedStrong = createAction(
    this.prefix + 'Balance updated strong',
    props<{
      account: BankkontoDTO;
    }>(),
  );

  public static resetBalanceStrongAuthenticationExceptionOccurred = createAction(
    this.prefix + 'Reset balanceStrongAuthenticationExceptionOccurred mark.',
  );

  public static setExecutiondate = createAction(
    this.prefix + 'Set executiondate',
    props<{
      executiondate?: string;
    }>(),
  );

  public static logout = createAction(this.prefix + 'Triggers the logout.');

  public static openFailureMessageDialog = createAction(
    this.prefix + 'Open failure message dialog.',
    props<{
      inhaberId: string;
      message: string;
    }>(),
  );

  public static closeFailureMessageDialog = createAction(
    this.prefix + 'Close failure message dialog and route to login page.',
  );

  public static openSessionExpiredDialog = createAction(
    this.prefix + 'Open session expired dialog.',
    props<{
      inhaberId: string;
    }>(),
  );

  public static closeSessionExpiredDialog = createAction(
    this.prefix + 'Close session expired dialog and route to login page.',
  );
}
